export const DropDownActionTypes = {
	GET_DROPDOWN_START: 'GET_DROPDOWN_START',
	GET_DROPDOWN_SUCCESS: 'GET_DROPDOWN_SUCCESS',
	GET_DROPDOWN_FAILURE: 'GET_DROPDOWN_FAILURE',
	GET_DDDATA_START: 'GET_DDDATA_START',
	GET_DDDATA_SUCCESS: 'GET_DDDATA_SUCCESS',
	GET_DDDATA_FAILURE: 'GET_DDDATA_FAILURE',

}